import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {Editor} from '../editor-components';
import ShowReleases from './show-releases';
import ShowMetadata from './show-metadata';
import ShowPolicies from './show-policies';
import ShowFundraising from './show-fundraising';
import ShowBackgrounds from './show-backgrounds';
import ShowBeneficiaries from './show-beneficiaries';

export default class ShowEditor extends Component {
  constructor(props) {
    super(props);
    const expoID = props.match.params.expoID
    const showID = props.match.params.showID
    this.dataURL = `/expos/${expoID}/shows/${showID}`;
  }
  render() {
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Releases</Tab>
            <Tab>Properties</Tab>
            <Tab>Background Images</Tab>
            <Tab>Fundraising</Tab>
            <Tab>Policies</Tab>
            <Tab>Beneficiaries</Tab>
          </TabList>
          <TabPanel>
            <ShowReleases dataURL={this.dataURL}/>
          </TabPanel>
          <TabPanel>
            <ShowMetadata dataURL={this.dataURL}/>
          </TabPanel>
          <TabPanel>
            <ShowBackgrounds dataURL={this.dataURL}/>
          </TabPanel>
          <TabPanel>
            <ShowFundraising dataURL={this.dataURL}/>
          </TabPanel>
          <TabPanel>
            <ShowPolicies dataURL={this.dataURL}/>
          </TabPanel>
          <TabPanel>
            <ShowBeneficiaries dataURL={this.dataURL}/>
          </TabPanel>
        </Tabs>
      </Editor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/show-editor/show-editor.js